
import { defineComponent, PropType } from 'vue'
import { EmployeeRouteNames } from '@/router/routes-names'
import { useRoute, useRouter } from 'vue-router'
import { EmployeeModel, useEmployeeModule } from '@/modules/employees'
import usePaginationHelper from '@/views/_shared/search-list/pagination-helper'
import Uuid from '@/components/_shared/uuid.vue'

export default defineComponent({
    name: 'employees-list',
    components: { Uuid },
    props: {
        employees: {
            type: Array as PropType<EmployeeModel[]>,
            required: true
        }
    },
    setup () {
        const route = useRoute()
        const { pagination } = usePaginationHelper('email')

        const employeeColumns = ([
            {
                name: 'id',
                label: 'Id',
                field: 'id',
                sortable: true,
                align: 'left'
            },
            {
                name: 'email',
                label: 'Email',
                field: 'email',
                sortable: true,
                align: 'left'
            },
            {
                name: 'firstName',
                label: 'First Name',
                field: 'firstName',
                sortable: true,
                align: 'left'
            },
            {
                name: 'lastName',
                label: 'Last Name',
                field: 'lastName',
                sortable: true,
                align: 'left'
            },
            {
                name: 'roles',
                label: 'Roles',
                field: 'roles',
                sortable: true,
                align: 'left'
            },
            {
                name: 'actions',
                label: 'Actions',
                field: 'actions',
                align: 'left'
            }
        ])

        const {
            block,
            unblock,
            loadEmployees
        } = useEmployeeModule()
        const router = useRouter()

        function onEditEmployee (props: EmployeeModel) {
            router.push({
                name: EmployeeRouteNames.EDIT,
                params: { id: props.id },
                query: { page: route.query.page }
            })
        }

        function onShowEmployee (evt: PointerEvent | null, props: EmployeeModel) {
            router.push({
                name: EmployeeRouteNames.SINGLE,
                params: { id: props.id },
                query: { page: route.query.page }
            })
        }

        const onBlock = (props: EmployeeModel) => block(props.id).then(loadEmployees)
        const onUnblock = (props: EmployeeModel) => unblock(props.id).then(loadEmployees)

        return {
            onBlock,
            onUnblock,
            onShowEmployee,
            employeeColumns,
            onEditEmployee,
            pagination
        }
    }
})
